import React, { useRef, useState, useLayoutEffect } from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';
import { useText } from 'common/hooks';
import { ICON } from 'resources/constants';

import { Container, Icon, TagWrapper, Tag } from './elements';

const deps = {
  tags: state.challenge.log.computedTags,
  selectedTag: state.challenge.log.selectedTag,
  tagClicked: sequences`challenge.log.tagClicked`,
};

function Filter({
  tags,
  selectedTag,
  tagClicked,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const targetRef = useRef<HTMLDivElement>();
  const [height, setHeight] = useState(0);
  const [expanded, setExpanded] = useState(false);

  useLayoutEffect(() => {
    if (targetRef.current) {
      setHeight(targetRef.current.offsetHeight);
    }
  }, []);

  return (
    <Container $expanded={expanded} $expandedHeight={`${height}px`}>
      {height !== 38 && (
        <Icon
          icon={expanded ? ICON.keyboardArrowUp : ICON.keyboardArrowDown}
          onClick={() => setExpanded(!expanded)}
        />
      )}

      <TagWrapper ref={targetRef}>
        {tags
          .filter(
            tag => tag !== 'tutorial' && t.has(`challenge.tags.${tag}.name`)
          )
          .map(tag => (
            <Tag
              tagOnClick={() => tagClicked({ tag })}
              key={tag}
              selected={tag === selectedTag}
            >
              {t(`challenge.tags.${tag}.name`)}
            </Tag>
          ))}
      </TagWrapper>
    </Container>
  );
}

export default connect(deps, Filter);
